import styles from './SearchInput.module.css';
import { useProductsHook, useSearchHook, useLanguageHook } from '../../../Hooks/use-context-hooks';

import { IconComponent } from '../../Icon/IconComponent';
import { PageText } from '../../Text/Text';
import LinkedLogo from '../../Logo/LinkedLogo';
import {


    normalize,
    calculateMatchScore

} from '../../../Utils/search-helper';
export const SearchInput = () => {

    const { publicProducts } = useProductsHook();
    const productDataSearch = publicProducts;
      const {language, translatedText} =useLanguageHook();

    const {
        isMobileSearchState,
        setIsMobileSearchState,
        isDesktopSearchState,
        setIsDesktopSearchState,
        // isHomepageSearchState,
        setIsHomepageSearchState,
    } = useSearchHook();


    if (isMobileSearchState.isMobileSearch === true) {
        const handleMobileSearchChange = (event) => {
            const query = event.target.value.toLowerCase();

            setIsMobileSearchState(prevState => ({ ...prevState, isSearchInputValue: query }));

            if (query) {
                // const filteredResults = unifiedFilteredProducts(productDataSearch, query);
                const queryWords = query.trim().toLowerCase().split(/[\s-]+/).map(normalize);
                const queryJoined = queryWords.join('');

                const filteredResults = productDataSearch
                    .map(product => {
                        const matchScore = calculateMatchScore(product, queryWords, queryJoined);
                        return { product, matchScore };
                    })
                    .filter(({ matchScore }) => matchScore > 0) // Only matched products
                    .sort((a, b) => b.matchScore - a.matchScore) // Sort by highest score
                    .map(({ product }) => product); // Extract sorted products

                setIsHomepageSearchState(prevState => ({ ...prevState, isSearchResults: filteredResults }));

                setIsMobileSearchState(prevState => ({ ...prevState, isSearchResults: filteredResults }));
            } else {
                setIsMobileSearchState(prevState => ({ ...prevState, isSearchResults: [] }));
            }
            // }
        }

        const handleCloseMobileSearchOverlay = () => {
            setIsMobileSearchState(prevState => ({
                ...prevState,
                isMobileSearch: false,
                isSearchResults: []
            }))
            setIsHomepageSearchState(prevState => ({
                ...prevState,
                // isHomepageSearch: false,
                isSearchResults: []
            }))

        }


        const searchCountStyles = isMobileSearchState && isMobileSearchState.isSearchResults.length === 0
            ? styles.noResultsCount
            : styles.activeResultsCount;
        const searchCountTextStyles = isMobileSearchState && isMobileSearchState.isSearchResults.length === 0
            ? styles.noResultsCount
            : styles.activeResultsCountText;

        return (
            <div className={styles.searchInputContainer}>
                <div className={styles.searchInputHeaderText}>
                    <div className={styles.headerLogo}>
                        <LinkedLogo type='lgRedFaced' />
                        {/* <IconComponent iconType="searchInput" /> */}
                    </div>
                    <div className={styles.headerText}>
                        <PageText type='bodyCalloutTitle'>{translatedText.exploreHA}</PageText>
                    </div>


                </div>

                <div className={styles.searchInputWrapper}>
                    <div className={styles.searchIconWrapper}>
                        <IconComponent onClick={handleCloseMobileSearchOverlay} iconType='leftArrow' iconStyleType='leftArrowIcon' />
                    </div>

                    <input
                        type="search"
                        placeholder={translatedText.searchPLHA}
                        onChange={handleMobileSearchChange}
                        aria-label="Search home appliances"
                        className={`${styles.input} ${isMobileSearchState.isSearchActive ? styles.active : ''}`}
                    />
                </div>
                <div className={styles.searchInputFooterText}>
                    <p>
                        <span className={searchCountStyles}>{isMobileSearchState.isSearchResults.length} </span>
                        <span className={searchCountTextStyles} >{translatedText.results}</span>
                    </p>
                    

                  
                </div>

            </div>
        );
    }


    if (isDesktopSearchState.isDesktopSearch === true) {

        const handleDesktopSearchChange = (event) => {
            const query = event.target.value.toLowerCase();

            setIsDesktopSearchState(prevState => ({ ...prevState, isSearchInputValue: query }));
            if (query) {

                const queryWords = query.trim().toLowerCase().split(/[\s-]+/).map(normalize);
                const queryJoined = queryWords.join('');

                // const filteredResults = productDataSearch.filter((product) => {
                //     const matchesBasicFields = (product.title?.toLowerCase().includes(query) ?? false)
                //         || (product.subtitle?.toLowerCase().includes(query) ?? false)
                //         || (product.category?.toLowerCase().includes(query) ?? false);

                //     const matchesSpecList = (list) => list?.some(spec => spec.toLowerCase().includes(query)) ?? false;
                //     const matchesSpecs = matchesSpecList(product.specList1)
                //         || matchesSpecList(product.specList2)
                //         || matchesSpecList(product.specList3)
                //         || matchesSpecList(product.specList4);

                //     const matchesColors = product.colors?.some(color => color.includes(query)) ?? false;
                //     const matchesLogos = product.logos?.some(logo => logo.includes(query)) ?? false;

                //     return matchesBasicFields || matchesSpecs || matchesColors || matchesLogos;
                // });

                const filteredResults = productDataSearch
                    .map(product => {
                        const matchScore = calculateMatchScore(product, queryWords, queryJoined);
                        return { product, matchScore };
                    })
                    .filter(({ matchScore }) => matchScore > 0) // Only matched products
                    .sort((a, b) => b.matchScore - a.matchScore) // Sort by highest score
                    .map(({ product }) => product); // Extract sorted products
                setIsDesktopSearchState(prevState => ({ ...prevState, isSearchResults: filteredResults }));
            } else {
                setIsDesktopSearchState(prevState => ({ ...prevState, isSearchResults: [] }));
            }

        }

        const handleDesktopSearchFocus = () => {
            setIsDesktopSearchState(prevState => ({ ...prevState, isSearchFocused: true }));
        }
        return (
            <div className={styles.searchInputContainer}>
                <div
                    className={`${styles.searchInputWrapper} ${isDesktopSearchState.isSearchActive ? styles.active : ''} ${isDesktopSearchState.isSearchResults.length > 0 ? styles.withResults : ''}`}
                >
                    <div className={styles.desktopSearchIconWrapper}>
                        <IconComponent iconType='searchInput' />
                    </div>

                    <input
                        type="search"
                      placeholder={translatedText.searchPLHA}
                        onChange={handleDesktopSearchChange}
                        value={isDesktopSearchState.isSearchInputValue}
                        onFocus={handleDesktopSearchFocus}
                        aria-label="Search home appliances"
                        // className={`${styles.input} ${isDesktopSearchState.isSearchActive ? styles.active : ''}`}
                        className={`${styles.input} ${isDesktopSearchState.isSearchActive ? styles.active : ''} ${isDesktopSearchState.isSearchResults.length > 0 ? styles.withResults : ''}`}

                    />
                </div>
            </div>
        );
    }



};